import React from "react";
import { DialogContentText } from "@material-ui/core";
import { withSnackbar } from "notistack";
import Popup from "components/popup";
import { toast } from "react-toastify";
import { withRouter } from "react-router-dom";

export default withSnackbar(
  withRouter(function (props) {
    const {
      isOpen,
      setClose,
      student,
      commentIndex,
      comments,
      user,
      setStudent,
      editStudent,
    } = props;
    const [saveLoading, setSaveLoading] = React.useState(false);

    const handleDeleteComment = () => {
      if (user && user != null) {
        setSaveLoading(true);

        let newComments = [];

        for (let [i, c] of comments.entries()) {
          if (i != commentIndex) {
            newComments.push(c);
          }
        }

        let patchData = { ...student, comments: newComments };

        setSaveLoading(true);
        toast.dark(`Deleting comment`);
        editStudent(student._id, patchData, user.idToken)
          .then((result) => {
            setStudent(result);
            setClose();
            setSaveLoading(false);
            toast.success(`Comment deleted`);
            setClose();
          })
          .catch((error) => {
            toast.error("Oops! Something went wrong.");
            toast.dark(error.message);
            setSaveLoading(false);
          });
      }
    };

    return (
      <Popup
        title="Delete comment"
        isOpen={isOpen}
        handleCancel={() => setClose()}
        handleAction={() => handleDeleteComment()}
        actionButtonTitle="Yes, I'm sure."
        disabled={saveLoading}
        content={
          <div>
            <DialogContentText>
              Are you sure you want to remove this comment ?
            </DialogContentText>
          </div>
        }
      />
    );
  })
);
